/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { intlShape } from 'react-intl';
import MetaData from '../MetaData';

class WorkMetaData extends Component {
  render() {
    const { work, title } = this.props;

    const props = {
      image: work.image.url,
      title
    };
    return <MetaData {...props} />;
  }
}

WorkMetaData.propTypes = {
  intl: intlShape.isRequired,
  work: PropTypes.shape({
    title: PropTypes.string.isRequired,
    artist: PropTypes.shape({
      name: PropTypes.string.isRequired
    }),
    image: PropTypes.shape({
      url: PropTypes.string.isRequired
    })
  }),
  title: PropTypes.string.isRequired
};

WorkMetaData.displayName = 'WorkMetaData';

WorkMetaData.fragment = gql`
  fragment WorkMetaData on Work {
    title
    artist {
      name
    }
    image {
      url
    }
  }
`;

export default WorkMetaData;
